import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-view-owner-application-details',
  templateUrl: './view-owner-application-details.component.html',
  styleUrls: ['./view-owner-application-details.component.css']
})
export class ViewOwnerApplicationDetailsComponent implements OnInit {

  @Input() applicationInfo: any;
  @Input() visible: boolean = false;
  imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/"

  isRejected: boolean; 


  constructor() { }

  ngOnInit(): void {
    console.log('Info :: ', this.applicationInfo); 
    console.log('Status :: ', this.applicationInfo.status);

    if(this.applicationInfo.status === 'REJECTED') {
      this.isRejected = true; 
    }
  }

}
